import { Controller } from '@hotwired/stimulus'
import { populateAndShowModal } from '../helpers/feature_gate_modal'

export default class extends Controller {
  static values = {
    feature: String,
    tier: String,
    title: String,
    description: String,
    tierLabel: String,
    tierColor: String,
    tierBg: String,
    upgradeUrl: String,
    locked: { type: Boolean, default: true },
    price: String
  }

  connect () {
    if (!this.lockedValue) return

    this._injectLockIcon()
    this._addTooltip()
  }

  openModal (event) {
    event.preventDefault()
    event.stopPropagation()

    populateAndShowModal({
      tierLabel: this.tierLabelValue,
      title: this.titleValue,
      description: this.descriptionValue,
      tier: this.tierValue,
      upgradeUrl: this.upgradeUrlValue,
      price: this.hasPriceValue ? this.priceValue : ''
    })
  }

  // --- Private-ish helpers ---

  _injectLockIcon () {
    const target = this.element.querySelector('button, a, .btn')
    if (!target) return
    if (target.querySelector('.feature-gate-lock-icon')) return

    const icon = document.createElement('i')
    icon.className = 'fas fa-lock feature-gate-lock-icon'
    target.prepend(icon)
  }

  _addTooltip () {
    this.element.setAttribute('title', `Requires ${this.tierLabelValue} plan`)

    if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
      new bootstrap.Tooltip(this.element, { trigger: 'hover' })
    }
  }
}
